import { GradeKey } from '@/externals/gyym/user/grades'
import { PassKey } from './types'

/**
 * サーバサイドで持っているGradeの形式(`user_grade_standard`) を、
 * フロントエンドで取り回すPass名(`standard`)の形式に変換する
 */
export const getPassKey = (gradeKey: GradeKey | PassKey): PassKey => {
  return gradeKey.replace('user_grade_', '') as PassKey
}
